/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CspServiceRole { 
    /**
     * Role name
     */
    name?: string;
    /**
     * Resource
     */
    resource?: string;
    /**
     * Membership type
     */
    membershipType?: string;
    /**
     * Whether assigned via group
     */
    assignedViaGroup?: boolean;
    /**
     * Group IDs
     */
    groupIds?: Array<string>;
}

